import requestManager from "@/utils/client";
import upLoadRequest from "@/utils/uploadAjaxClient";
// 发送短信验证码接口
export function onFetchMessage(params) {
    return requestManager
        .request({
            url: "/user/sendSecurityCode",
            method: "post",
            data: params
        });
}
// （内勤端）登录(现有接口)
export function onLoginWithPhone(params) {
    return requestManager
        .request({
            url: "/user/loginOrRegister",
            method: "post",
            data: params
        });
}
export function onLoginWithPhoneJiaJiHua(params) {
    return requestManager
        .request({
            url: "/user/loginOrRegisterJiaJiHua",
            method: "post",
            data: params
        });
}
// （客户端）查询当前登录人下面的客户信息
export function onSelectXinWeiLaiPersonPrivilegeList(params) {
    return requestManager
        .request({
            url: "/user/selectXinWeiLaiPersonPrivilegeList",
            method: "post",
            data: params
        });
}
// （客户端）查询证书
export function onSelectCertXinWeiLai(params) {
    return requestManager
        .request({
            url: "/user/selectCertXinWeiLai",
            method: "post",
            data: params
        });
}

// 图片上传接口
export function onUploadImage(params) {
    return upLoadRequest
        .request({
            url: "/system/uploadImg",
            method: "post",
            data: params
        });
}
// （客户端）确认签字接口
export function onConfirmSign(params) {
    return requestManager
        .request({
            url: "/user/confirmSign",
            method: "post",
            data: params
        });
}
// （客户端）查询历史视频
export function onSelectVideoXinWeiLai(params) {
    return requestManager
        .request({
            url: "/user/selectVideoXinWeiLai",
            method: "post",
            data: params
        });
}
// （客户端）根据id查询客户信息
export function onSelectXinWeiLaiPersonPrivilege(params) {
    return requestManager
        .request({
            url: "/user/selectXinWeiLaiPersonPrivilege",
            method: "post",
            data: params
        });
}